export const GET_ASSESSMENT_SUMMARY = 'GET_ASSESSMENT_SUMMARY';
export const FETCH_ASSESSMENT_SUMMARY_START = 'FETCH_ASSESSMENT_SUMMARY_START';
export const FETCH_ASSESSMENT_SUMMARY_SUCCESS =
  'FETCH_ASSESSMENT_SUMMARY_SUCCESS';
export const FETCH_ASSESSMENT_SUMMARY_ERROR = 'FETCH_ASSESSMENT_SUMMARY_ERROR';
export const SET_DOCUMENT_METADATA_SELECTED = 'SET_DOCUMENT_METADATA_SELECTED';
